<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="95" label-position="right"
                                  :loading="loading" ref="form">
                                <!--<FormItem :label="t.menu.catalog" prop="division">-->
                                <FormItem :label="t.menu.catalog" prop="division">
                                    <Input v-model.trim="formItem.divisionName"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.catalog)" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.menu.type" prop="type">
                                    <RadioGroup v-model.trim="formItem.type" type="button" size="small">
                                        <Radio :label="item.type" :key="item.type" :disabled="item.disabled"
                                               v-for="item in typeList">
                                            {{item.name}}
                                        </Radio>
                                    </RadioGroup>
                                </FormItem>
                                <transition name="fade" mode="out-in">
                                    <!--<FormItem :label="t.menu.parentName" prop="parentName">-->
                                    <FormItem :label="t.menu.parentName">
                                        <Input v-model.trim="formItem.parentName"
                                               :placeholder="msgUtil.placeholderRequired(t.menu.parentName)"
                                               readonly>
                                            <Button slot="append" @click="openTreeModal">
                                                {{t.menu.selected}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                </transition>
                                <FormItem :label="nameChange" prop="name">
                                    <Input v-model.trim="formItem.name" :maxlength="10"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.menuName)"></Input>
                                </FormItem>
                                <FormItem :label="t.menu.icon" prop="icon">
                                    <AutoComplete
                                        v-model.trim="formItem.icon"
                                        :icon="formItem.icon"
                                        :placeholder="msgUtil.placeholderSelected(t.menu.icon)"
                                        style="width:200px" ref="autoCom">
                                        <div style="height:200px;width:200px">
                                            <Icon style="cursor: pointer;padding: 4px 4px;" :value="item" :key="item"
                                                  v-for="item in msgUtil.iconList" :label="item"
                                                  :type="item" size="20"
                                                  @click.native="handleClickIcon(item)"/>
                                        </div>
                                    </AutoComplete>
                                </FormItem>
                                <FormItem :label="t.menu.url" prop="url">
                                    <Input v-model.trim="formItem.url" :maxlength="100"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.url)"></Input>
                                </FormItem>
                                <FormItem :label="t.menu.permit" prop="permit">
                                    <Input v-model.trim="formItem.permit" :maxlength="100"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.permit)"></Input>
                                </FormItem>
                                <FormItem :label="t.menu.sortOrder" prop="sortOrder">
                                    <InputNumber v-model.trim="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.menu.status" prop="status">
                                    <i-switch v-model.trim="formItem.status" :disabled="disabledStatus" size="large"
                                              true-value="1" false-value="0">
                                        <span slot="open">{{t.menu.statusOpen}}</span>
                                        <span slot="close">{{t.menu.statusClose}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading"
                                            @click="handleAddSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()"
                                            style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Modal
            :title='msgUtil.message.action.add'
            v-model.trim="treeNode.modal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false">
            <Row>
                <Col style="padding-left:20px;height:300px;overflow-x: auto;margin-bottom:10px;">
                    <!--<Tree :data="nodeList" :render="renderContent" @on-selected="selectTreeNode" />-->
                    <Tree ref="tree" :data="nodeList"/>
                </Col>
            </Row>
            <Row>
                <Col style="padding-left:20px;" span="14">
                    <Alert v-if="treeNode.error" style="padding: 6px 48px 6px 38px;" type="error" show-icon>
                        {{msgUtil.placeholderSelected(t.menu.parentName)}}
                    </Alert>
                </Col>
                <Col style="text-align:right;">
                    <Button type="primary" @click="handleSubmitTreeNode">
                        {{msgUtil.message.action.submit}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import { add, edit, getMenuInfo, getSubTreeMenuList } from '@/api/menu';
import ZkTable from '@/components/Table/Table';

export default {
    name: 'organization_menu_edit',
    components: {
        ZkTable,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItemBK: {},
            formItem: {
                method: 'GET',
                parentId: '',
                name: '',
                icon: '',
                url: '',
                permit: '',
                sortOrder: 0,
                type: '',
                status: '1',
                division: '',
                divisionName: '',
                parentName: '',
                hasChildren: false,
                disabledParentStatus: true,
            },
            treeNode: {
                modal: false,
                error: false,
            },
            divisionList: [{ name: t.menu.frontEndName, division: '1' }, { name: t.menu.backEndName, division: '2' }],
            typeList: [
                { name: t.menu.typeMenu, type: 'm', disabled: false },
                {
                    name: t.menu.typeButton,
                    type: 'b',
                    disabled: false,
                },
            ],
            disabledStatus: false,
            nodeList: [],
            ruleValidate: {
                division: [
                    {
                        required: true,
                        message: msgUtil.errorSelected(t.menu.catalog),
                        trigger: 'change',
                    },
                ],
                type: [
                    {
                        required: true,
                        message: msgUtil.errorSelected(t.menu.type),
                        trigger: 'change',
                    },
                ],
                parentName: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.parentName),
                        trigger: 'change',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.menuName),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 20,
                        message: msgUtil.errorMaxLength(t.menu.menuName, 20),
                        trigger: 'blur',
                    },
                ],
                icon: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.icon),
                        trigger: 'change',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.menu.icon, 100),
                        trigger: 'blur',
                    },
                ],
                url: [
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.menu.url, 100),
                        trigger: 'blur',
                    },
                ],
                permit: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.permit),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.menu.permit, 100),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    computed: {
        nameChange() {
            if (this.formItem.type === 'b') {
                return this.t.menu.buttonName;
            }
            return this.t.menu.menuName;
        },
    },
    methods: {
        getDivisionName(val) {
            return val === '1' ? this.divisionList[0].name : this.divisionList[1].name;
        },
        async treeMenuListSetting() {
            //得到后台所有菜单展示
            const treeMenuList = await getSubTreeMenuList({
                division: this.formItem.division,
                type: this.formItem.type,
                excludeId: this.formItem.id,
            });
            this.nodeList = treeMenuList.menus;
        },
        handleClickIcon(val) {
            this.formItem.icon = val;
            //this.$refs.autoCom.$refs.select.visible = false;
        },
        handleAddSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.loading = true;
                    const menuDto = {};
                    menuDto.method = this.formItem.method;
                    menuDto.parentId = this.formItem.parentId;
                    menuDto.name = this.formItem.name;
                    menuDto.icon = this.formItem.icon;
                    menuDto.url = this.formItem.url;
                    menuDto.permit = this.formItem.permit;
                    menuDto.sortOrder = this.formItem.sortOrder;
                    menuDto.type = this.formItem.type;
                    menuDto.status = this.formItem.status;
                    menuDto.division = this.formItem.division;
                    const res = await edit(this.$route.params.id, menuDto);
                    this.nodeList = [];
                    Object.assign(this.formItemBK, this.formItem);
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.loading = false;
            //this.$refs.form.resetFields();
            this.nodeList = [];
            Object.assign(this.formItem, this.formItemBK);
        },
        async openTreeModal() {
            await this.treeMenuListSetting();
            this.treeNode.error = false;
            this.treeNode.modal = true;
        },
        handleSubmitTreeNode() {
            let choicesAll = this.$refs.tree.getSelectedNodes(); //方法的运用 getSelectedNodes也是如此用法
            if (choicesAll.length === 0) {
                this.treeNode.error = true;
                return;
            }
            this.formItem.parentId = choicesAll[0].id;
            this.formItem.parentName = choicesAll[0].name;
            this.treeNode.modal = false;
            this.treeNode.error = false;
        },
        async init() {
            const menuInfo = await getMenuInfo(this.$route.params.id);
            if (menuInfo.menu != null) {
                this.formItem = menuInfo.menu;
                this.formItem.divisionName = this.getDivisionName(this.formItem.division);
                if (this.formItem.type === 'm' && this.formItem.hasChildren) {
                    this.typeList[1].disabled = true;
                }
                if (this.formItem.disabledParentStatus) {
                    this.formItem.status = '0';
                    this.disabledStatus = true;
                }
                Object.assign(this.formItemBK, this.formItem);
            }

            //console.log(this.$refs.autoCom);
        },
    },
   async mounted() {
        await this.init();
       // this.$refs.autoCom.$refs.select.hideMenu();
   },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
